import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const { $charge, $inputs } = this;

  return (view = ViewFactory({
    NAME: '1VOUCHER_INIT_VIEW',
    inputs: ['phone', 'voucher'],
    constants: { hasBackAction: false },
    next() {
      const pin = getValueAtPath($inputs, '[voucher].value');
      const phonenumber = getValueAtPath($inputs, '[phone].value');

      if (pin && phonenumber) {
        $charge.init({
          data: { pin, phonenumber }
        });
      }
    }
  }).call(this));
}
